
/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *    .       .       .       .       .       .       .       .       .       .       .       .
 *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 * Copyright FortyFix(c) 2024.
 * Title: SanPellegrino.ts;
 * Path: /Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/GESFF_Gestionale_FF_Angular/src/environments/Modules/Sanpellegrino/SanPellegrino.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 03/12/25, 09:28;
 *
 *
 */

import {Coupon} from "./Coupon";
import {AssegnazioneCoupon} from "./AssegnazioneCoupon";
import {EnvironmentModel} from "../../BaseEnvironments/Model";
import {Agenti} from "./Agenti";
import {addModule} from "../../Utility/ModuleUtility";
import {assegnazioneClientiEnv} from "./assegnazioneClienti";
import {Prodotti} from "./Prodotti";
import {ReportCoupon} from'./ReportCoupon';
import {ReportSpedizioni} from'./ReportSpedizioni';
import {ReportAssegnazioni} from "./ReportAssegnazioni";
import {ClientiAgentiEnv} from "./ClientiAgenti";
import {reportkpi} from "./ReportKpi";
var RuoliOperativiRef = [{id:"DM", label: "District Manager"},{id:"NAM", label: "NAM"}]


export var SanPellegrinoEnv = () => {
  var env: EnvironmentModel = {
    Modules: {
      "SanPellegrino": true
    },
    ProdottiAddOn: {
      CampiAggiuntivi:[
        {
          modificabile: true,
          nome: "Templates",
          oggetti: ["stampeFile"],
          inputType: 'singleDropdown',
          source: "/prodotti/coupon/stampe",
          internalOutput: `stampeFile`,

          placeholder: 'Seleziona',
          settings: {
            singleSelection: false,
            closeDropDownOnSelection: true,
            singleOutput: false,
            idField: 'id',
            textField: "description",
            searchPlaceholderText: "Cerca",
            allowSearchFilter: false,
            allowRemoteDataSearch: false,

          },
          hideif: {
            func: (x, y) => {
              return true
            }
          },
          class: "col-lg-3",
          visibleifProhibited: true
        },
      ]
    },
    Cruds: [Coupon(), AssegnazioneCoupon(), Agenti(), Prodotti(), ReportCoupon(), ReportSpedizioni(), ReportAssegnazioni(), reportkpi()],
    Menu: [...Coupon().MenuItems, ...AssegnazioneCoupon().MenuItems, ...Agenti().MenuItems, ...Prodotti().MenuItems, ...ReportCoupon().MenuItems, ...ReportSpedizioni().MenuItems, ...ReportAssegnazioni().MenuItems, ...reportkpi().MenuItems]
  }
  env = addModule(assegnazioneClientiEnv(),env)
  env = addModule(ClientiAgentiEnv(),env);
  return env;

}


//NOTE:

/*
*  - come vengono associati nam e dm a SP? referenti del cliente
*  - aggiungiamo una relazione tra persone e nella maschera del profilo di una persone si aggiunge la maschera tipo referenti per associare gli agenti ->  campo dm, dmObject nell'agente
*
*
*
la differenziazione del tipo di ruolo come avviene  tra DM Agente e NAm? ruolo operativo DM o NAM
ok, le credenziali te le mando alla generazione del referente? o funziona come progetti che sta la chiamata che genera e invia le credenziali ?
*/

export function RuoliAccesso(ruolo: "DM" | "NAM"|"Agente" ){
 return RuoliAccessoObject(ruolo).map(x=>x.id);
}
export function RuoliAccessoObject(ruolo: "DM" | "NAM"|"Agente"): {id:number, ruolo:string}[]{
  switch (ruolo){
    case "DM":
      return [{id:24, ruolo:"DM"}];
    case "NAM":
      return [{id:25, ruolo:"NAM"}];
    case "Agente":
      return [{
        id: 26,
        ruolo: "Agente Sanpellegrino"
      }]
    default:
      return []
  }
}

export function RuoliOperativi(ruoliAccesso: {id:number, ruolo:string}[]){
  if(isDM(ruoliAccesso))
    return["DM"]
  if(isNAM(ruoliAccesso))
    return["NAM"]
  if(isAgente(ruoliAccesso))
    return["AG"]
  return []
}
export function RuoliOperativiObject(item: {ruoliAccesso?: {id: number, ruolo: string}[], ruolo?: "DM" | "NAM"|"AG"}){
  if(item?.ruoliAccesso?.find(x=>RuoliAccesso("DM").includes(x.id)) || item.ruolo == "DM" )
    return[RuoliOperativiRef.find(x=>x.id=="DM")]
  if(item?.ruoliAccesso?.find(x=>RuoliAccesso("NAM").includes(x.id)) || item.ruolo == "NAM")
    return[RuoliOperativiRef.find(x=>x.id == "NAM")]
  if(item?.ruoliAccesso?.find(x=>RuoliAccesso("Agente").includes(x.id)) || item.ruolo == "AG")
    return[RuoliOperativiRef.find(x=>x.id == "AG")]
  return []
}
export function isDM(ruoliAccesso: {id:number, ruolo:string}[]){
  return ruoliAccesso.find(x=>RuoliAccesso("DM").includes(x.id));
}
export function isNAM(ruoliAccesso: {id:number, ruolo:string}[]){
  return ruoliAccesso.find(x=>RuoliAccesso("NAM").includes(x.id));
}
export function isAgente(ruoliAccesso: {id:number, ruolo:string}[]){
  return ruoliAccesso.find(x=>RuoliAccesso("Agente").includes(x.id));
}

export function stampa_id(coupon):number|undefined{
  return coupon.stampe?.length ? coupon.stampe[0]?.id: undefined;
}

export function CouponType(coupon: {posizione:string}): "SI"|"SO"|"OM"{
  return CouponTypeObject(coupon).id;
}
export function CouponTypeObject(coupon: {posizione:string}): {id:"SI"|"SO"|"OM", label:string,prezzo?:number}{
  return CouponTypes().find(x=>x.condition(coupon)) ?? {id:"SO", label:"Sell-out"}
}

export function CouponTypes():{id:"SI"|"SO"|"OM", label:string, prezzo?:number, condition:(coupon:{posizione:string})=>boolean}[]{
  return [
    {id:"SI", label: "Sell-in", prezzo: 20, condition:(coupon:{posizione:string})=>{return coupon.posizione == "SI"}},
    {id:"SO", label: "Sell-out", prezzo: 110, condition:(coupon:{posizione:string})=>{return coupon.posizione == "SO"}},
    {id:"OM", label: "Omaggio", prezzo: 0, condition:(coupon:{posizione:string})=>{return coupon.posizione == "OM"}},
  ]
}


export function UserIs(ruolo: "DM"|"NAM"|"AG"|"S", user: any){
  return user?.ruoliObject?.find(x=> x.id?.toUpperCase() == ruolo.toUpperCase());
}
export function StoredUserIs(ruolo: "DM"|"NAM"|"AG"|"S"){
  var user = StoredUser()
  return user?.ruoliObject?.find(x=> x.id?.toUpperCase() == ruolo.toUpperCase());
}
export function StoredUser(){
  return JSON.parse(localStorage.getItem("currentUser") ?? "{}");
}
